/**
 * SGKC023A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CtrPeriodInfo {

    /**
     * 開始年月日
     */
    ctrStartYmd?: string;
    /**
     * 終了年月日
     */
    ctrEndYmd?: string;
}

